import React, { type FC } from 'react';

export const EmptySearchIconMedium: FC = () => (
  <svg
    width="100"
    height="86"
    viewBox="0 0 100 86"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3239_10361)">
      <g clipPath="url(#clip1_3239_10361)">
        <path
          d="M93.4763 23.7309C88.7245 20.6233 81.065 19.2814 71.916 19.8464C63.4054 8.26344 48.299 3.10761 35.0366 8.19281C21.7742 13.278 14.6111 27.0504 16.8806 41.0347C9.93022 46.6849 5.32029 52.6883 4.18554 58.056C3.76 60.1042 6.10043 61.7992 7.80256 60.5986C11.4905 57.8441 15.8877 55.019 20.8522 52.1939C20.994 52.1232 21.1359 52.0526 21.2777 51.982C23.9018 65.7544 30.994 77.0548 44.0437 79.103C57.8026 81.2219 70.4976 72.8172 74.6111 57.3497L78.2281 54.8071C79.6465 53.8183 80.2848 52.0526 79.7884 50.4282C78.5118 46.4024 76.1004 38.9865 75.2494 35.667L75.1784 35.8789C74.8238 34.3251 74.3274 32.8419 73.6891 31.4293C74.8948 31.1468 76.1004 30.8643 77.2352 30.5818C82.838 29.3105 88.0863 28.3923 92.7671 27.9686C94.7529 27.7567 95.2494 24.9316 93.4763 23.7309Z"
          fill="#EAF0FA"
        />
        <path
          d="M34.9652 8.05156C33.1921 9.88788 31.4191 16.6681 33.2631 23.0246"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M34.5391 7.48654C40.6384 7.48654 50.993 13.5605 53.9717 21.3296"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M35.8171 6.42712C34.3987 7.27465 34.5406 0 37.0937 0C39.576 0 37.9448 5.22645 35.8171 6.42712Z"
          fill="#EAF0FA"
        />
        <path
          d="M33.6896 6.85089C35.2498 6.63901 32.8385 2.75448 30.6399 3.8139C28.3704 4.94394 31.491 7.1334 33.6896 6.85089Z"
          fill="#EAF0FA"
        />
        <path
          d="M66.0284 46.8968C66.851 46.8968 67.5178 46.2328 67.5178 45.4136C67.5178 44.5945 66.851 43.9304 66.0284 43.9304C65.2059 43.9304 64.5391 44.5945 64.5391 45.4136C64.5391 46.2328 65.2059 46.8968 66.0284 46.8968Z"
          fill="#031D44"
        />
        <path
          d="M40.9941 82.705C43.2636 83.6938 45.4622 84.2589 45.4622 84.2589C46.8097 84.6826 48.2282 83.9057 48.6537 82.4932C49.0792 81.1512 48.2991 79.7387 46.8807 79.3149L49.5757 80.0918C50.9232 80.5156 52.3417 79.7387 52.7672 78.3261C53.1927 76.9842 52.4126 75.5716 50.9941 75.1479L54.0438 76.066C55.3913 76.4898 56.8097 75.7129 57.2353 74.3003C57.6608 72.8878 56.8807 71.5459 55.4622 71.1221L41.9161 67.1669L49.4339 64.4831"
          stroke="#031D44"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M66.0297 63.5649C76.0961 63.5649 84.2566 55.4383 84.2566 45.4136C84.2566 35.3889 76.0961 27.2623 66.0297 27.2623C55.9632 27.2623 47.8027 35.3889 47.8027 45.4136C47.8027 55.4383 55.9632 63.5649 66.0297 63.5649Z"
          stroke="#031D44"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M52.9805 70.0627L57.3067 61.7992"
          stroke="#031D44"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M64.1143 67.8026C63.1214 69.7802 61.4902 70.6983 61.4902 70.6983"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3239_10361">
        <rect width="100" height="85.1064" fill="white" />
      </clipPath>
      <clipPath id="clip1_3239_10361">
        <rect
          width="99.2908"
          height="85.1064"
          fill="white"
          transform="translate(0.355469)"
        />
      </clipPath>
    </defs>
  </svg>
);
